import styles from '@/components/SliderPromotions/SliderPromotions.module.scss'
import cn from 'classnames'
import { adaptiveText } from '@/components/SliderPromotions/SliderPromotions.helpers'
import { ISliderCard } from '@/components/SliderPromotions/components/SliderCard/SliderCard.interface'
import { OperatingSystem } from '@/constants'

export const SliderCard = ({
  promo,
  setSelectedPartnerPromotion,
  setOpenModalPromo,
  setOpenModalLinks,
  operatingSystem,
  ios_link,
}: ISliderCard) => {
  return (
    <div className={styles.containerSlide}>
      <a
        target="_blank"
        href={
          operatingSystem === OperatingSystem.IOS && promo.transition_type === 'functional'
            ? ios_link
            : promo.url
        }
        onClick={evt => {
          if (operatingSystem === OperatingSystem.Android) {
            if (promo.transition_type === 'functional') {
              evt.preventDefault()
              setOpenModalLinks(true)
            }
          }
        }}
        className={styles.slide}
        style={{
          backgroundImage: `url(${promo.media.background_url})`,
        }}
      >
        <div
          className={styles.containerImage}
          style={{ backgroundImage: `url(${promo.media.overlay_url})` }}
        ></div>
        {promo.partner.name && (
          <div
            className={styles.promo__nameplate}
            onClick={evt => {
              evt.preventDefault()
              evt.stopPropagation()
              setSelectedPartnerPromotion(promo)
              setOpenModalPromo(true)
            }}
          >
            Реклама
          </div>
        )}
        <article className={cn(styles.promo, { [styles.promo_noDesc]: !promo.description })}>
          {promo.name && <h3 className={styles.promo__title}>{adaptiveText(promo.name)}</h3>}
          {promo.description && (
            <p className={styles.promo__desc}>{adaptiveText(promo.description)}</p>
          )}
        </article>
      </a>
    </div>
  )
}
